var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$store.getters["session/isLogged"]
    ? _c(
        "IdleTracker",
        [
          _c("ChangeUserModal", {
            model: {
              value: _vm.$store.state.layout.changeUserModalVisible,
              callback: function($$v) {
                _vm.$set(_vm.$store.state.layout, "changeUserModalVisible", $$v)
              },
              expression: "$store.state.layout.changeUserModalVisible"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("loading-anim", {
                attrs: {
                  active: _vm.$store.state.loading,
                  fullScreen: "",
                  toggleParentClass: ""
                }
              }),
              _vm._v(" "),
              _c("PrivateLayoutMenu", {
                attrs: {
                  menuItems: _vm.allItems,
                  menuServiceItems: _vm.menuServiceItems
                }
              }),
              _vm._v(" "),
              !_vm.$uiHelpers.isDesktop
                ? _c("PrivateLayoutMobileSubmenu", {
                    attrs: {
                      menuItems: _vm.allItems,
                      menuServiceItems: _vm.menuServiceItems
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("menu-banners"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pb-5 custom-container" },
                [
                  _vm.showTabsMenu
                    ? _c(
                        "b-tabs",
                        { attrs: { fill: "" } },
                        _vm._l(
                          _vm.menuItems.filter(function(item) {
                            return item.tab !== false
                          }),
                          function(tab) {
                            return _c("b-tab", {
                              key: tab.path,
                              attrs: {
                                title: tab.title,
                                active: _vm.isTabActive(tab.path)
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onTabClick(tab)
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "title",
                                    fn: function() {
                                      return [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t" +
                                            _vm._s(tab.title) +
                                            "\n\t\t\t\t\t\t"
                                        ),
                                        tab.bubble
                                          ? _c(
                                              "b-badge",
                                              { attrs: { variant: "info" } },
                                              [_vm._v(_vm._s(tab.bubble))]
                                            )
                                          : _vm._e()
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          }
                        ),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("router-view", {
                    class: { "pt-5": _vm.$helpers.inIframe() }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b064a07", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b064a07","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/PrivateLayout.vue
// module id = 2071
// module chunks = 116